import { render, staticRenderFns } from "./AttributeListView.vue?vue&type=template&id=851521c0&scoped=true"
import script from "./AttributeListView.vue?vue&type=script&lang=js"
export * from "./AttributeListView.vue?vue&type=script&lang=js"
import style0 from "./AttributeListView.vue?vue&type=style&index=0&id=851521c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851521c0",
  null
  
)

export default component.exports